import { render, staticRenderFns } from "./TokenChooser.vue?vue&type=template&id=48665667&scoped=true&"
import script from "./TokenChooser.vue?vue&type=script&lang=ts&"
export * from "./TokenChooser.vue?vue&type=script&lang=ts&"
import style0 from "./TokenChooser.vue?vue&type=style&index=0&id=48665667&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48665667",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QAvatar,QIcon});
